import { makeApiTypes } from 'sidecar-utility-library'

export const types = {
  // Account
  ...makeApiTypes('FETCH_SETTINGS', 'account'),
  ...makeApiTypes('UPDATE_SETTINGS', 'account'),
  ...makeApiTypes('MAIL_CHECK', 'account'),
  ...makeApiTypes('FETCH_OUTSTANDING_EXPENSES', 'account'),
  ...makeApiTypes('TOGGLE_AUTOPAYMENT_EXPENSE', 'account'),
  ...makeApiTypes('FETCH_AUTOPAYMENT_EXPENSE', 'account'),
  ...makeApiTypes('FETCH_ACCOUNT_METADATA', 'account'),
  INITIALIZE_OUTSTANDING_EXPENSES: 'account/INITIALIZE_OUTSTANDING_EXPENSES',

  // Documents
  ...makeApiTypes('DELETE_DOCUMENT', 'account'),
  ...makeApiTypes('FETCH_DOCUMENTS', 'account'),
  ...makeApiTypes('UPLOAD_DOCUMENT', 'account'),
  ...makeApiTypes('VIEW_DOCUMENT', 'account'),
  UPLOAD_DOCUMENT_VALIDATION_ERROR: 'account/UPLOAD_DOCUMENT_VALIDATION_ERROR',
  CLEAR_DOCUMENTS: 'account/CLEAR_DOCUMENTS',

  // Document Errors
  CLEAR_DELETE_ERRORS: 'account/CLEAR_DELETE_ERRORS',
  CLEAR_UPLOAD_ERRORS: 'account/CLEAR_UPLOAD_ERRORS',

  // Survey
  ...makeApiTypes('FETCH_SURVEY_ANSWER', 'account'),
  ...makeApiTypes('FETCH_SURVEY_OPTIONS', 'account'),
  ...makeApiTypes('SUBMIT_SURVEY_ANSWER', 'account'),

  // Get Redirect Paytient Link
  ...makeApiTypes('FETCH_REDIRECT', 'account'),
  ...makeApiTypes('FETCH_STATUS', 'account'),

  // Get Financial account balance (tax credit)
  ...makeApiTypes('FETCH_FINANCIAL_ACCOUNT_BALANCE', 'account'),
  ...makeApiTypes('FETCH_MONEY_BACK_SUMMARY', 'account'),
}

export const initialState = {
  notificationSettings: {
    fetching: false,
    error: null,
    entities: {},
  },
  paytient: {
    busy: false,
    entity: {},
    error: '',
  },
  mailCheck: {
    busy: false,
    error: null,
  },
  outstandingExpenses: {
    busy: false,
    error: null,
    entities: [],
  },
  autopaymentExpense: {
    entity: false,
    busy: false,
    error: null,
  },
  documents: {
    busy: false,
    entities: [],
    error: '',
    uploadBusy: false,
    uploadError: '',
    url: '',
    viewBusy: false,
    viewError: '',
    deleteBusy: false,
    deleteError: '',
  },
  survey: {
    answer: {
      entity: {},
      busy: false,
      error: '',
    },
    options: {
      entity: [],
      busy: false,
      error: '',
    },
  },
  accountMetadata: {
    busy: false,
    entity: {},
    error: '',
  },
  financialBalance: {
    entities: [],
    busy: false,
    error: '',
  },
  moneyBackSummary: {
    busy: false,
    entity: {},
    error: '',
  },
}
